<template>
  <div class="main-wrapper">
    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span
                      class="font-weight-600 text-slate-300"
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h6 class="text-muted">Create Your Account</h6>
              <p
                v-if="invitationData && !hideJoinLabel"
                class="text-muted mt-2"
              >
                Join <strong>{{ invitationData.businessName }}</strong> as
                {{ invitationData.roleName || "a member" }}
              </p>
              <div class="mt-4">
                <div
                  v-if="success === true && message"
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                >
                  <strong>Success!</strong> {{ message }}
                </div>
                <div
                  v-if="success === false && message"
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                >
                  {{ message }}
                </div>
              </div>
            </div>

            <form class="vld-parent" ref="formContainer">
              <!-- First Name -->
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  required
                  v-model="firstName"
                  name="firstName"
                  placeholder="First name"
                />
              </div>

              <!-- Last Name -->
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  required
                  v-model="lastName"
                  name="lastName"
                  placeholder="Last name"
                />
              </div>

              <!-- Email (readonly if from invitation) -->
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  required
                  v-model="email"
                  name="email"
                  placeholder="Email address"
                  :readonly="invitationData && invitationData.email"
                  :style="
                    invitationData && invitationData.email
                      ? { backgroundColor: '#f5f5f5' }
                      : {}
                  "
                />
              </div>

              <!-- Phone (optional) -->
              <div class="form-group">
                <input
                  type="tel"
                  class="form-control"
                  id="phone"
                  v-model="phone"
                  name="phone"
                  placeholder="Phone number (optional)"
                  :readonly="
                    invitationData &&
                      invitationData.phone &&
                      !invitationData.email
                  "
                  :style="
                    invitationData &&
                    invitationData.phone &&
                    !invitationData.email
                      ? { backgroundColor: '#f5f5f5' }
                      : {}
                  "
                />
              </div>

              <!-- Password -->
              <div class="form-group" style="position: relative;">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  id="password"
                  required
                  v-model="password"
                  name="password"
                  placeholder="Create a password"
                  autocomplete="new-password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="togglePassword($event)"
                >
                  <i v-if="showPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
              </div>

              <!-- Confirm Password -->
              <div class="form-group mb-4" style="position: relative;">
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  class="form-control"
                  id="confirmPassword"
                  required
                  v-model="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm your password"
                  autocomplete="new-password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="toggleConfirmPassword($event)"
                >
                  <i v-if="showConfirmPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
              </div>

              <div class="text-center">
                <button
                  class="btn btn-primary btn-block account-btn"
                  type="button"
                  @click="register()"
                  :style="{
                    backgroundColor: branding.buttonColor,
                    color: branding.buttonTextColor,
                    borderColor: branding.buttonColor
                  }"
                  :disabled="loading"
                >
                  <span v-if="!loading">Create Account</span>
                  <span v-else>
                    <i
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
                <button
                  class="btn btn-primary btn-block account-btn mt-2"
                  type="button"
                  @click="goBack()"
                  :style="{
                    backgroundColor: 'white',
                    color: branding.buttonColor,
                    borderColor: branding.buttonColor
                  }"
                >
                  Cancel
                </button>
              </div>
            </form>

            <div class="text-center dont-have">
              <div class="mt-3">
                <small id="terms-footnote" class="footnote">
                  {{ branding.footerText }}
                  <a
                    :href="branding.privacyPolicyUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    privacy policy
                  </a>
                  and
                  <a
                    :href="branding.termsUrl"
                    target="_blank"
                    :style="{ color: branding.primaryColor }"
                  >
                    terms and conditions
                  </a>
                  that govern your usage of our services.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrandingByDomain } from "@/config/domainBranding";
import authServiceApi from "../../service/AuthServiceApi";

export default {
  name: "InvitationRegister",
  data() {
    return {
      success: null,
      message: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      invitationData: null,
      invitationId: null,
      hideJoinLabel: true,
      branding: getBrandingByDomain(location.host)
    };
  },
  computed: {
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || "#ffffff",
        fontWeight: "bold",
        backgroundColor:
          this.branding.logo.suffixBackgroundColor ||
          this.branding.primaryColor,
        padding: "6px",
        borderRadius: "5px"
      };
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      };
    }
  },
  methods: {
    togglePassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword(e) {
      e.preventDefault();
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    goBack() {
      this.$router.push("/join-business");
    },
    validateForm() {
      if (!this.firstName) {
        this.success = false;
        this.message = "First name is required";
        return false;
      }
      if (!this.lastName) {
        this.success = false;
        this.message = "Last name is required";
        return false;
      }
      if (!this.email) {
        this.success = false;
        this.message = "Email is required";
        return false;
      }
      if (!this.password) {
        this.success = false;
        this.message = "Password is required";
        return false;
      }
      if (this.password.length < 6) {
        this.success = false;
        this.message = "Password must be at least 6 characters";
        return false;
      }
      if (!this.confirmPassword) {
        this.success = false;
        this.message = "Please confirm your password";
        return false;
      }
      if (this.password !== this.confirmPassword) {
        this.success = false;
        this.message = "Passwords do not match";
        return false;
      }
      return true;
    },
    async register() {
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;
      this.success = null;
      this.message = "";

      try {
        const data = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          password: this.password,
          confirmPassword: this.confirmPassword,
          domain: location.host
        };

        const response = await authServiceApi.acceptInvite(
          this.invitationId,
          data
        );

        if (response.data.code === "SUCCESS" || response.data.success) {
          // Clear session storage
          sessionStorage.removeItem("invitationData");

          // Navigate to success screen
          this.$router.push({
            name: "invitation-success",
            query: {
              businessName:
                (this.invitationData && this.invitationData.businessName) || "",
              email: this.email
            }
          });
        } else if (response.data.code === "MEMBERSHIP_ALREADY_EXISTS") {
          sessionStorage.removeItem("invitationData");
          // Navigate to success screen with existing user flag
          this.$router.push({
            name: "invitation-success",
            query: {
              businessName:
                (this.invitationData && this.invitationData.businessName) || "",
              email: this.email,
              isExistingUser: "true"
            }
          });
        } else {
          this.success = false;
          this.message =
            response.data.description ||
            response.data.narrative ||
            "Failed to create account";
        }
      } catch (e) {
        console.error("Error creating account:", e);
        this.success = false;
        if (e.response && e.response.data) {
          this.message =
            e.response.data.narrative ||
            e.response.data.description ||
            "Failed to create account";
        } else {
          this.message = "Something went wrong. Please try again.";
        }
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    // Get invitation ID from route
    this.invitationId = this.$route.query.invitationId;

    // Check if hideJoinLabel flag is explicitly set to false (to show the label)
    // By default, hideJoinLabel is true (label is hidden)
    if (this.$route.query.hideJoinLabel === "false") {
      this.hideJoinLabel = false;
    }

    // Get invitation data from session storage
    const storedData = sessionStorage.getItem("invitationData");
    if (storedData) {
      this.invitationData = JSON.parse(storedData);
      // Pre-fill email and phone from invitation
      if (this.invitationData.email) {
        this.email = this.invitationData.email;
      }
      if (this.invitationData.phone) {
        this.phone = this.invitationData.phone;
      }
    }

    // If no invitation data, redirect back
    if (!this.invitationId) {
      this.$router.push("/join-business");
    }
  }
};
</script>

<style scoped>
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.1em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/auth/InvitationRegister.vue